<template>
    <div class="user-detail">
        <div class="box">
            <div class="title">基础信息</div>
            <el-row>
                <el-col :span="8">
                    <span class="label">苇渡ID：</span>
                    <span class="value">{{ detail.wdId }}</span>
                </el-col>
                <el-col :span="8">
                    <el-row type="flex">
                        <span class="label">头像：</span>
                        <img class="avatar" :src="detail.avatar">
                    </el-row>
                </el-col>
                <el-col :span="8">
                    <span class="label">昵称：</span>
                    <span class="value">{{ detail.nickname }}</span>
                </el-col>
            </el-row>
            <el-row style="margin-top: 10px;">
                <el-col :span="8">
                    <span class="label">手机号码：</span>
                    <span class="value">{{ detail.phone }}</span>
                </el-col>
                <el-col :span="8">
                    <span class="label">邮箱：</span>
                    <span class="value">{{ detail.email }}</span>
                </el-col>
                <el-col :span="8">
                    <span class="label">注册时间：</span>
                    <span class="value">{{ detail.regTime }}</span>
                </el-col>
            </el-row>
        </div>
        <div class="box">
            <div class="title">历史总数据</div>
            <el-button-group>
                <el-button :type="currentFlyer == 'FlyerEVO' ? 'primary' : 'default'"
                    @click="handleFlyTotal('FlyerEVO')">FlyerEVO</el-button>
                <el-button :type="currentFlyer == 'FP10' ? 'primary' : 'default'"
                    @click="handleFlyTotal('FP10')">FP10</el-button>
            </el-button-group>
            <el-row>
                <el-col :span="6">
                    <div class="card">
                        <div class="name">总里程</div>
                        <div class="data">{{ flyTotal.totalMileage }}</div>
                    </div>
                </el-col>
                <el-col :span="6">
                    <div class="card">
                        <div class="name">最高速度</div>
                        <div class="data">{{ flyTotal.maxSpeed }}</div>
                    </div>
                </el-col>
                <el-col :span="6">
                    <div class="card">
                        <div class="name">总使用时间</div>
                        <div class="data">{{ flyTotal.totalUsageTime }}</div>
                    </div>
                </el-col>
                <el-col :span="6">
                    <div class="card">
                        <div class="name">平均速度</div>
                        <div class="data">{{ flyTotal.averageSpeed }}</div>
                    </div>
                </el-col>
                <el-col :span="6">
                    <div class="card">
                        <div class="name">单次最长时间</div>
                        <div class="data">{{ flyTotal.singleLongestTime }}</div>
                    </div>
                </el-col>
                <el-col :span="6">
                    <div class="card">
                        <div class="name">单次最长续航</div>
                        <div class="data">{{ flyTotal.singleLongestEndurance }}</div>
                    </div>
                </el-col>
                <el-col :span="6">
                    <div class="card">
                        <div class="name">活跃天数</div>
                        <div class="data">{{ flyTotal.activeDays }}</div>
                    </div>
                </el-col>
                <el-col :span="6">
                    <div class="card">
                        <div class="name">飞行次数</div>
                        <div class="data">{{ flyTotal.flightTimes }}</div>
                    </div>
                </el-col>
            </el-row>
        </div>
        <div class="box">
            <div class="title">设备激活信息</div>
            <el-table>
                <el-table-column label="序号" type="index" width="100"></el-table-column>
                <el-table-column label="激活时间" prop="activationTime"></el-table-column>
                <el-table-column label="产品名称" prop="productName"></el-table-column>
                <el-table-column label="别名" prop="alias"></el-table-column>
                <el-table-column label="SN码" prop="snCode"></el-table-column>
            </el-table>
            <div class="flex justify-end mt-3">
                <el-pagination :current-page="activationQuery.pageNo" layout="total, sizes, prev, pager, next, jumper"
                    :total="activationTotal" @size-change="handleActivationSizeChange"
                    @current-change="handleActivationCurrentChange">
                </el-pagination>
            </div>
        </div>
        <div class="box">
            <div class="title">设备使用数据</div>
            <el-table>
                <el-table-column label="时间" prop="createTime"></el-table-column>
                <el-table-column label="设备名称" prop="deviceName"></el-table-column>
                <el-table-column label="设备类型" prop="deviceType"></el-table-column>
                <el-table-column label="耗时" prop="duration"></el-table-column>
                <el-table-column label="时速" prop="speed"></el-table-column>
                <el-table-column label="里程" prop="mileage"></el-table-column>
            </el-table>
            <div class="flex justify-end mt-3">
                <el-pagination :current-page="usageQuery.pageNo" layout="total, sizes, prev, pager, next, jumper"
                    :total="usageTotal" @size-change="handleUsageSizeChange" @current-change="handleUsageCurrentChange">
                </el-pagination>
            </div>
        </div>
    </div>
</template>

<script>
import { detail, flyTotal, deviceActivation, deviceUsage } from "@/api/user/list";
export default {
    data() {
        return {
            detail: {},
            currentFlyer: 'FlyerEVO',
            flyTotal: {},
            activationQuery: {
                userId: '',
                deviceType: '',
                pageNo: 1,
                pageSize: 10
            },
            activationTotal: 0,
            usageQuery: {
                userId: '',
                deviceType: '',
                pageNo: 1,
                pageSize: 10
            },
            usageTotal: 0,
            deviceActivation: [],
            deviceUsage: []
        }
    },
    created() {
        this.id = this.$route.query.id;
        this.getDetail();
        this.getFlyTotal();
        this.getDeviceActivation();
        this.getDeviceUsage();
    },
    methods: {
        getDetail() {
            detail({ id: this.id }).then(({ code, result, message }) => {
                if (code == 200) {
                    this.detail = result || {};
                } else {
                    this.$message.error(message);
                }
            });
        },
        getFlyTotal() {
            flyTotal({ userId: this.id, deviceType: this.currentFlyer }).then(({ code, result, message }) => {
                if (code == 200) {
                    this.flyTotal = result || {};
                } else {
                    this.$message.error(message);
                }
            });
        },
        getDeviceActivation() {
            const params = {
                ...this.activationQuery,
                userId: this.id,
                deviceType: this.currentFlyer
            }
            deviceActivation(params).then(({ code, result, message }) => {
                if (code == 200) {
                    this.deviceActivation = result.records || [];
                    this.activationTotal = result.total;
                } else {
                    this.$message.error(message);
                }
            });
        },
        getDeviceUsage() {
            const params = {
                ...this.usageQuery,
                userId: this.id,
                deviceType: this.currentFlyer
            }
            deviceUsage(params).then(({ code, result, message }) => {
                if (code == 200) {
                    this.deviceUsage = result.records || [];
                    this.usageTotal = result.total;
                } else {
                    this.$message.error(message);
                }
            });
        },
        handleFlyTotal(type) {
            this.currentFlyer = type;
            this.getFlyTotal();
        },
        handleActivationSizeChange(size) {
            this.activationQuery.pageSize = size;
            this.getDeviceActivation();
        },
        handleActivationCurrentChange(current) {
            this.activationQuery.pageNo = current;
            this.getDeviceActivation();
        },
        handleUsageSizeChange(size) {
            this.usageQuery.pageSize = size;
            this.getDeviceUsage();
        },
        handleUsageCurrentChange(current) {
            this.usageQuery.pageNo = current;
            this.getDeviceUsage();
        },
    }
}
</script>

<style lang="less" scoped>
.user-detail {
    display: flex;
    flex-direction: column;
    row-gap: 20px;
    background: #f5f5f5;

    .avatar {
        width: 50px;
        height: 50px;
        border-radius: 50%;
        object-fit: cover;
    }

    .box {
        padding: 10px 20px 20px;
        background: #fff;
        border-radius: 8px;
    }

    .card {
        background: #f9fbfc;
        margin: 10px;
        padding: 10px;
        border-radius: 8px;

        .name {
            color: #999;
            font-size: 14px;
        }

        .data {
            color: #333;
            font-size: 20px;
        }
    }
}
</style>